<template>
  <div class="flex-column h100">
    <navbar title="衣物预警"></navbar>
    <div class="subject flex1 flex-column h100 w100">
      <div class="flex">
        <div class="mt10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>超出时间</span>
            </div>
            <div>
              <div class="radio-time">
                <el-radio v-model="timeRadio" label="0">所有</el-radio>
              </div>
              <el-radio v-model="timeRadio" label="1">1天</el-radio>
              <el-radio v-model="timeRadio" label="2">2天</el-radio>
              <el-radio v-model="timeRadio" label="3">3天</el-radio>
              <el-radio v-model="timeRadio" label="7">1周</el-radio>
              <el-radio v-model="timeRadio" label="14">2周</el-radio>
              <el-radio v-model="timeRadio" label="30">1个月</el-radio>
            </div>
          </el-card>
        </div>
        <div class="mt10 ml10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>衣物状态</span>
            </div>
            <div>
              <div class="radio-time">
                <el-radio v-model="stateRadio" label="1">未完成</el-radio>
              </div>
              <el-radio v-model="stateRadio" label="2">收衣未入厂</el-radio>
              <el-radio v-model="stateRadio" label="3">已入厂未出厂</el-radio>
              <el-radio v-model="stateRadio" label="4">出厂未到店</el-radio>
              <el-radio v-model="stateRadio" label="5">返店未取衣</el-radio>
            </div>
          </el-card>
        </div>
        <div class="mt10 ml10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>其他筛选</span>
            </div>
            <div>
              <div class="radio-time">
                <el-checkbox v-model="checked">是否加快</el-checkbox>
              </div>
              <div class="mt10">
                选择门店:
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div class="flex-column flex1 mt10">
        <div>
          <el-card class="box-card1">
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 30, 40, 50]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableData.info.count"
                background
              ></el-pagination>
            </div>
          </el-card>
        </div>
        <div class="flex1 mt10">
          <el-table
            :data="tableData.list"
            border
            :height="tableHeight"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @row-dblclick="dblclick"
          >
            <el-table-column prop="create_time" label="下单时间" width="180"></el-table-column>
            <el-table-column prop="shop_order_no" label="订单号" width="180"></el-table-column>
            <el-table-column prop="shopName" label="所属门店"></el-table-column>
            <el-table-column prop="code_num" label="条形码"></el-table-column>
            <el-table-column prop="name" label="衣物名称"></el-table-column>
            <el-table-column prop="cloth_status" label="状态"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="wash_remark" label="洗衣方式、附加服务、附加费"></el-table-column>
            <el-table-column prop="total_price" label="价格"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 弹出层 -->
    <el-dialog
      title="详情跟踪"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :row-class-name="tableRowClassName"
    >
      <div class="border">
        <el-table :data="tableData.list" height="250" border style="width: 100%">
          <el-table-column prop="date" label="订单号" width="120"></el-table-column>
          <el-table-column prop="name" label="条形码"></el-table-column>
          <el-table-column prop="name" label="状态"></el-table-column>
          <el-table-column prop="name" label="门店"></el-table-column>
          <el-table-column prop="name" label="收衣店员"></el-table-column>
          <el-table-column prop="name" label="工厂洗衣师" width="120"></el-table-column>
          <el-table-column prop="address" label="备注" width="180"></el-table-column>
          <el-table-column prop="date" label="操作时间" width="120"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import header from '@/components/header'
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      tableHeight: window.innerHeight - 400,
      timeRadio: '0',
      stateRadio: '1',
      checked: false,
      options: [],
      value: '',
      tableData: {
        info: {},
        list: []
      },
      dialogVisible: false,
      page: 1,
      limit: 20
    }
  },
  created() {
    this.warn()
    this.$http.allShop()
      .then(res => {
        this.options = [{ id: null, name: "请选择" }, ...res.data.data]
      })
  },
  methods: {
    // 分页大小变化
    handleSizeChange(val) {
      this.limit = val
      this.warn()
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.page = val
      this.warn()
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
    // 关闭弹出框
    handleClose(done) {
      done();
    },
    // 
    dblclick(row) {
      console.log(row);
      this.dialogVisible = true
    },

    // 获取衣物预警数据
    async warn() {
      let data = {
        dayCount: parseInt(this.timeRadio),
        status: parseInt(this.stateRadio),
        shop_id: parseInt(this.value),
        is_urgent: this.checked ? 1 : 0,
        page: this.page,
        limit: this.limit
      }
      let res = await this.$http.warn(data)
      this.tableData = res.data.data
    }
  },
  watch: {
    timeRadio() {
      this.warn()
    },
    stateRadio() {
      this.warn()
    },
    value() {
      this.warn()
    },
    checked() {
      this.warn()
    }
  }
}
</script>
<style lang="less" scoped>
.subject {
  padding: 0 10px 30px 10px;
  box-sizing: border-box;
  .radio-time {
    width: 60px;
  }
}
.box-card {
  width: 320px;
  height: 180px;
}
.box-card1 {
  width: 100%;
}
</style>
<style lang="less">
// .subject {
//   .el-table {
//     height: 100% !important;
//     .el-table__body-wrapper {
//       height: 100% !important;
//     }
//   }
// }
</style>